import { render, staticRenderFns } from "./TeamDetail.vue?vue&type=template&id=36cf4f61&scoped=true"
import script from "./TeamDetail.vue?vue&type=script&lang=js"
export * from "./TeamDetail.vue?vue&type=script&lang=js"
import style0 from "./TeamDetail.vue?vue&type=style&index=0&id=36cf4f61&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cf4f61",
  null
  
)

export default component.exports